import {Map, Set} from 'immutable';

/**
 * Mapping of field whitelists for rendering special search UIs
 *
 * If you need to render only a subset of search fields, make a new
 * whitelist, and adjust code in SearchSidebarContainer.
 */
export default Map({
  addCallsByCallsTab: Set([
    'Keyword / Topic',
    'Has Comments',
    `Doesn't Have Comments`,
    'I Commented',
    'Has Highlights',
    `Doesn't Have Highlights`,
    'I Highlighted',
    'Duration',
    'Date',
    'Direction',
    'Coaching Requested',
  ]),
});
